<template>
    <div class="full-width" v-loading="loading">
        <ul class="inputs-ul">
            <li>
                <label tkey="公司名稱">{{i18n.tkey('lang_company_name')}}<requiredInputSpan /></label>
                <el-input
                    v-model="inputObj.companyname"
                    placeholder=""
                    clearable
                    show-word-limit
                    maxlength="50"
                />
            </li>

            <li>
                <label tkey="公司電郵">{{i18n.tkey('lang_company_email')}}<requiredInputSpan /></label>
                <el-input
                        v-model="inputObj.email"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="50"
                />
            </li>

            <li>
                <label tkey="電話區號">{{i18n.tkey('lang_area_code')}}<requiredInputSpan /></label><br>
                <areaNumberSelect v-model="inputObj.sharewhcom" style="width: 200px; display: inline-block;" />
            </li>

            <li>
                <label tkey="公司電話">{{i18n.tkey('lang_company_telphone')}}<requiredInputSpan /></label>
                <el-input
                        v-model="inputObj.telephone"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="35"
                />
            </li>

            <li>
                <label tkey="公司地址">{{i18n.tkey('lang_company_address')}}<requiredInputSpan /></label>
                <el-input
                        v-model="inputObj.address"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </li>

<!--            <li>-->
<!--                <label tkey="貨幣單位">{{i18n.tkey('lang_company_curr')}}<requiredInputSpan /></label><br>-->
<!--                <currSelect-->
<!--                        v-model="inputObj.curr"-->
<!--                        :placeholder="i18n.tkey('lang_company_curr')"-->
<!--                        style="width: 200px;display: inline-block"-->
<!--                />-->
<!--            </li>-->

            <li>
                <el-checkbox v-model="paypalFlag" :label="i18n.tkey('lang_open_shop_Transaction_fees_des')" size="large" />
            </li>

            <li>
                <el-text type="warning">{{i18n.tkey("lang_open_shop_Transaction_fees_des")}}</el-text>
            </li>

            <li style="margin-top: 50px">
                <el-collapse>
                    <el-collapse-item :title="i18n.tkey('lang_optional_information')" name="1">
                        <label tkey="公司電話2">{{i18n.tkey('lang_company_telphone_2')}}</label><br>
                        <el-input
                                v-model="inputObj.mobilephone"
                                placeholder=""
                                clearable
                                show-word-limit
                                maxlength="35"
                                style="margin-bottom: 10px"
                        />

                        <label tkey="公司傳真">{{i18n.tkey('lang_company_fax')}}</label><br>
                        <el-input
                                v-model="inputObj.fax"
                                placeholder=""
                                clearable
                                show-word-limit
                                maxlength="35"
                                style="margin-bottom: 10px"
                        />

                        <label tkey="公司網站">{{i18n.tkey('lang_company_website')}}</label><br>
                        <el-input
                                v-model="inputObj.website"
                                placeholder=""
                                clearable
                                show-word-limit
                                maxlength="30"
                                style="margin-bottom: 10px"
                        />
                    </el-collapse-item>
                </el-collapse>
            </li>

            <li class="operation-part">
                <el-button tkey="提交" type="primary" @click="submitData">{{i18n.tkey('lang_submit')}}</el-button>
            </li>
        </ul>

        <activateEShopopee v-if="null != companyObj" :companyObj="companyObj" @save-complete="saveCallback" />
    </div>
</template>

<script setup>
    import requiredInputSpan from "@/components/shopopee/form/requiredInputSpan"
    import areaNumberSelect from "@/components/shopopee/form/areaNumberSelect"
    import activateEShopopee from "@/components/shopopee/company/activateEShopopee"
    import currSelect from "@/components/shopopee/form/currSelect"
    import {getCurrentInstance, inject, toRef, ref, onMounted} from "vue";
    import { useCompanyinfo } from '@/stores/companyinfo'
    import { useUserinfo } from '@/stores/userinfo'
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import boApi from "@/request/boApi";
    import userApi from "@/request/userApi";

    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())

    const userinfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")
    const { proxy } = getCurrentInstance();

    const props = defineProps(["countrycode", 'tag'])
    const emits = defineEmits(["saveComplete"])

    const companyObj = ref(null)
    const loading = ref(false)
    const paypalFlag = ref(true)

    const inputObj = ref({
        companyname: null,
        email: null,
        telephone: null,
        address: null,
        companyname2: null,
        fax: null,
        website: null,
        sharewhcom: null,
        curr: null,
        mobilephone: null
    })

    function fillDefaultCompanyInfo(){
        inputObj.value.companyname = companyInfoRef.value.companyname
        inputObj.value.email = companyInfoRef.value.email
        inputObj.value.telephone = companyInfoRef.value.telephone
        inputObj.value.address = companyInfoRef.value.address
        inputObj.value.companyname2 = companyInfoRef.value.companyname2
        inputObj.value.fax = companyInfoRef.value.fax
        inputObj.value.website = companyInfoRef.value.website
        inputObj.value.sharewhcom = companyInfoRef.value.sharewhcom
        inputObj.value.mobilephone = companyInfoRef.value.mobilephone
    }

    function submitData(){
        if (myUtil.isEmpty(inputObj.value.companyname)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(inputObj.value.email)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(inputObj.value.telephone)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(inputObj.value.address)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        // if (myUtil.isEmpty(inputObj.value.curr)){
        //     myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
        //     return
        // }

        if (props.tag == 'edit' ){
            saveCompanyInfo()
        }else{
            addNewCompany()
        }
    }

    function saveCompanyInfo(){
        const request = companyApi.inputCompanyInfo
        const params = request.getParams()

        params.companycode = userinfoRef.value.companycode
        params.companyname = inputObj.value.companyname
        params.companyname2 = inputObj.value.companyname2
        params.email = inputObj.value.email
        params.telephone = inputObj.value.telephone
        params.fax = inputObj.value.fax
        params.website = inputObj.value.website
        params.address = inputObj.value.address
        params.login = userinfoRef.value.businessLogin
        params.userId = userinfoRef.value.businessId
        params.token = userinfoRef.value.token
        params.chatId = userinfoRef.value.addinfo2
        params.sharewhcom = inputObj.value.sharewhcom
        // params.currcode = inputObj.value.curr
        params.blockasp = 0
        params.mobilephone = inputObj.value.mobilephone


        request.send(params, (res) => {
            if (res.code == 200){
                loading.value = true
                const obj = res.detail

                if (paypalFlag.value){
                    obj.proxypay = 1
                }else{
                    obj.proxypay = 0
                }

                companyObj.value = obj
            }
        })

    }

    function addNewCompany(){
        const request = companyApi.newCountryCompany
        const params = request.getParams()

        params.id = userinfoRef.value.businessId
        params.addinfo2 = userinfoRef.value.addinfo2
        params.addinfo3 = inputObj.value.companyname
        params.country = props.countrycode
        params.token = userinfoRef.value.token
        params.email = inputObj.value.email
        params.telephone = inputObj.value.telephone
        params.address = inputObj.value.address
        params.attdate2 = inputObj.value.companyname2
        params.fax = inputObj.value.fax
        params.marital = inputObj.value.website
        params.salaryperiod = inputObj.value.sharewhcom
        // params.salaryaccount = inputObj.value.curr

        request.send(params, (res) => {
            if (res.code == 200){
                loading.value = true

                const obj = res.detail

                if (paypalFlag.value){
                    obj.proxypay = 1
                }else{
                    obj.proxypay = 0
                }

                companyObj.value = obj
            }
        })

    }

    function saveCallback(){
        loading.value = false
        companyObj.value = null
        emits("saveComplete")
    }

    onMounted(() => {
        fillDefaultCompanyInfo()
    })


</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .inputs-ul {
        width: 100%;
        list-style: none;
        padding-left: 0;
        text-align: left;
    }

    .inputs-ul li {
        margin-bottom: 10px;
    }

    .operation-part {
        text-align: center;
        margin-top: 20px;
    }
</style>